import FetchError from './FetchError';

export default class ForbiddenError extends FetchError {
  constructor(message: string = 'Forbidden') {
    super(message, 403);
  }
}
